module.exports = __webpack_public_path__ + "images/link@2x-e55b1613.png";